import styled from "styled-components";

export const IconButtonWrap = styled.div`
  position: absolute;
  top: -12px;
  right: -12px;
`;
